import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const PaymentList = lazy(() => import('./pages/paymentList'))

export const paymentsRoutes = () => {
  return (
    <>
      <Route path={pageUrl.payments} element={<PaymentList />} />
    </>
  )
}
